module.exports = {
	mounted: function mounted() {

		// Set up
		var idleDurationSecs = 1800; //30mins

		var redirectTo = '/logout';

		var methods = ['click', 'touchstart', 'mousemove'];

		var otherMethods = [];

		var idleTimeout = void 0;

		var resetIdleTimeout = function resetIdleTimeout() {

			// Clears the existing timeout
			if (idleTimeout) clearTimeout(idleTimeout);

			// Set new timeout
			idleTimeout = setTimeout(function () {
				return location.href = redirectTo;
			}, idleDurationSecs * 1000);
		};

		// Init on page load
		resetIdleTimeout();

		// Reset the idle timeout on any of the events listed below
		[].concat(methods, otherMethods).forEach(function (evt) {
			return document.addEventListener(evt, resetIdleTimeout, false);
		});
	}
};

// module.exports = Heartbeat;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/plugins/Heartbeat.js
// module id = zF4i
// module chunks = 0 1